<template>
  <v-carousel :height="height">
    <v-carousel-item
      v-for="(item, i) in items"
      :key="i"
      :src="item.src"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        src: "/images/espaco/1.jpg"
      },
      {
        src: "/images/espaco/2.jpg"
      },
      {
        src: "/images/espaco/3.jpg"
      },
      {
        src: "/images/espaco/4.jpg"
      },
      {
        src: "/images/espaco/5.jpg"
      },
      {
        src: "/images/espaco/6.jpg"
      },
      {
        src: "/images/espaco/7.jpg"
      },
      {
        src: "/images/espaco/8.jpg"
      },
      {
        src: "/images/espaco/9.jpg"
      },
      {
        src: "/images/espaco/10.jpg"
      }
    ]
  }),

  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "220px";
        case "sm":
          return "250px";
        case "md":
          return "350px";
        case "lg":
          return "450px";
        case "xl":
          return "500px";
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
